/* Componente Mini Mappa  */

import MiniMap from 'leaflet-minimap';
import { useLeaflet } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import './Control.MiniMap.css';

function MiniMappa() {
    const { map } = useLeaflet();
   
    useEffect(() => {
        const osmUrl="https://b.tile.openstreetmap.org/{z}/{x}/{y}.png";
        // Layer per Mini Mappa
        const osmTileLayer = new L.TileLayer(osmUrl, {minZoom: 0, maxZoom: 13});
        new MiniMap(osmTileLayer, { toggleDisplay: false}).addTo(map);
    },[]);
    return null;
};
export default MiniMappa;




